import { Atom, useAtomValue } from 'jotai';
import { Loadable } from 'jotai/vanilla/utils/loadable';

type LoadableResult<T, E> =
  | { state: 'loading' }
  | { state: 'hasData'; data: T }
  | { state: 'hasError'; error: E };

export const useLoadableAtomValue = <T, E = unknown>(
  atom: Atom<Loadable<Promise<T>>>
): LoadableResult<T, E> => {
  const result = useAtomValue(atom);

  if (result.state === 'hasError') {
    return {
      state: 'hasError',
      error: result.error as E,
    };
  }

  return result;
};
